/**
 * Greptile-style toggle button. Off = grey pill; On = blue pill.
 *
 * The visual model is the screenshot from Greptile's "When Greptile
 * Reviews" settings page: a thin track with a knob that slides when the
 * value flips. The control is keyboard-accessible (role=switch +
 * aria-checked); click and Space toggle.
 */
interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
}

export function Toggle({ checked, onChange, disabled, label }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`feluda-toggle ${checked ? 'feluda-toggle-on' : ''}`}
    >
      <span className="feluda-toggle-knob" />
    </button>
  );
}